import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api';

const STORE = 'files';
const fileThunk = {
  fetch: createAsyncThunk(
    `${STORE}/fetch`,
    async (args: { connectionId: string }, { rejectWithValue }) => {
      try {
        const { connectionId } = args;
        const files = await api.file.fetch({
          connectionId,
        });
        return files;
      } catch (error) {
        console.error('send message', error);
        return rejectWithValue(error.message as string);
      }
    }
  ),
  sendFiles: createAsyncThunk(
    `${STORE}/sendFiles`,
    async (args: { id: string; files: File[] }, { rejectWithValue }) => {
      try {
        const { id, files } = args;
        const message = await api.lawyerConnection.postFiles({
          id,
          files,
        });
        return message;
      } catch (error) {
        console.error('send message', error);
        return rejectWithValue(error.message as string);
      }
    }
  ),
};

export default fileThunk;
